export const simplePropertyReducer = (defaultState: any) => (state: any = defaultState) => state;
